module.exports = __webpack_public_path__ + "static/media/xwf_customers.07b39ca8.csv";